import {useResourcesToken} from '@/di/di.root-container.hooks';

import {PropsWithChildren} from 'react';

import cn from 'classnames';

import {Image} from '@/ui/kit/Image/Image';
import {TBankLogo} from '@/ui/kit/TBankLogo/TBankLogo';
import {ProjectLogo} from '@/ui/kit/icons/ProjectLogo';

import {MainPageIntroAnimation} from '../MainPageAnimation/MainPageIntroAnimation';

import s from './Intro.module.css';

interface Props {
  className?: string;
}

export function Intro({children, className}: PropsWithChildren<Props>): JSX.Element {
  const {title, background} = useResourcesToken().content.InviteIntro;

  return (
    <section className={cn(s.root, className)}>
      <Image src={background.image} alt={background.alt} className={s.background} />
      <div className={s.content}>
        <TBankLogo className={s.logo} />
        <ProjectLogo className={s.projectLogo} />
        <h1 className={s.title}>{title}</h1>
        <div className={s.animationPlaceholder} />
        <MainPageIntroAnimation />

        {children}
      </div>
    </section>
  );
}
